import HTTP_GESCOM from '@/api/HTTP_GESCOM';

const URL_BASE = 'gescom/Affectation/';

export async function getAffectationProduitUnitaireAsync(produits, avecDevis) {
  const response = await HTTP_GESCOM.post(`${URL_BASE}PGetAffectationProduitUnitaireAsync`, { produits, avecDevis });
  return response;
}
